
import { useContext, useMemo } from 'react';
import { getCTMSLAOList, RolesMap } from 'containers/protocol/protocoldetail/components/Arms/userRoleHooks';
import { AppContext } from '@ctsu/loader';


export const useCanViewProtocol = (protocolLead) => {
  const context = useContext(AppContext);
  const { session, application } = context;
  const ctmsLaoList = getCTMSLAOList(application?.appConfig)

  const userRoles = session?.userSiteRolePermissions
    ?.map(siteRole => siteRole?.roles?.map(r => r?.displayName?.trim()))
    ?.flat() || [];

  const userLaoGroups = session?.userGroups || [];

  // Check for restricted roles
  const isCtmsRegistrar = userRoles.some(role =>
    role?.toLowerCase() === RolesMap.CTMS_REGISTRAR.toLowerCase()
  );

  const isProtocolPI = userRoles.some(role =>
    role?.toLowerCase() === RolesMap.PROTOCOL_PRINCIPAL_INVESTIGATOR.toLowerCase()
  );

  const isProtocolClientAdmin = userRoles.some(role =>
    role?.toLowerCase() === RolesMap.PROTOCOL_CLIENT_ADMINISTRATOR.toLowerCase()
  );

  // If user doesn't have any of these restricted roles, they have full access
  const hasRestrictedRole = isCtmsRegistrar || isProtocolPI || isProtocolClientAdmin;

  if (!hasRestrictedRole) {
    return true; // Unrestricted access
  }

  // CTMS Registrar: Can view all CTMS-mapped trials
  if (isCtmsRegistrar && ctmsLaoList.includes(protocolLead)) {
    return true;
  }

  // Protocol PI or Client Admin: Can view trials led by their organization
  if ((isProtocolPI || isProtocolClientAdmin) && protocolLead) {
    return userLaoGroups.includes(protocolLead);
  }
  return false;
};


export const useDBInstance = () => {
  const context = useContext(AppContext);
  const { application } = context;
  const dbName = application?.dbName;
  return dbName || 'ctsu';
}

export const PROTOCOL_SETUP_HIDDEN_DB_INSTANCES = process.env.REACT_APP_PROTOCOL_SETUP_HIDDEN_DB_INSTANCES

export const shouldHideProtocolSetupRoutesForDbInstance = (dbInstance) => (
  PROTOCOL_SETUP_HIDDEN_DB_INSTANCES.includes((dbInstance || '').toLowerCase())
);

export const useShouldHideProtocolSetupRoutes = () => {
  const dbInstance = useDBInstance();
  return shouldHideProtocolSetupRoutesForDbInstance(dbInstance);
};

export const filterProtocolSetupRoutes = (routes = [], shouldHideProtocolSetupRoutes = false) => (
  shouldHideProtocolSetupRoutes
    ? routes.filter(route => !route?.path?.includes('/protocol-setup'))
    : routes
);

export const useFilteredProtocolSetupRoutes = (routes = []) => {
  const shouldHideProtocolSetupRoutes = useShouldHideProtocolSetupRoutes();
  return useMemo(
    () => filterProtocolSetupRoutes(routes, shouldHideProtocolSetupRoutes),
    [routes, shouldHideProtocolSetupRoutes]
  );
};